import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SsoCallbackPage = () => {
    const { loginWithToken } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const success = params.get('success');
        const token = params.get('token');
        const error = params.get('error');

        if (success === 'true' && token) {
            loginWithToken(token).then((result: any) => {
                if (result.success) {
                    navigate('/modules', { replace: true });
                } else {
                    navigate('/signin?error=' + encodeURIComponent(result.error || 'SSO login failed'), { replace: true });
                }
            });
        } else {
            navigate('/signin?error=' + encodeURIComponent(error || 'SSO login failed'), { replace: true });
        }
    }, [location, loginWithToken, navigate]);

    return (
        <div className="sso-loading">
            <div className="spinner"></div>
            <p>Processing login...</p>
        </div>
    );
};

export default SsoCallbackPage;
